import { render, staticRenderFns } from "./cash-on-delivery.vue?vue&type=template&id=c51f9248"
import script from "./cash-on-delivery.vue?vue&type=script&lang=js"
export * from "./cash-on-delivery.vue?vue&type=script&lang=js"
import style0 from "./cash-on-delivery.vue?vue&type=style&index=0&id=c51f9248&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports